//
// Standard winline animations
//
// A winline animation must have the following function
// - animate(x, y, symbolIndex, numSymbols, value, completeCallback)

// -------------------------------
// None winline animator
// -------------------------------
noneAnimator = {};

noneAnimator.playAnimation = function (sequence, callback) {
  timerManager.addTimer(1, undefined, callback);
};

noneAnimator.skipAnimation = function () {
  catMullRomAnimator.animationTime = catMullRomAnimator.totalAnimationTime;
};

resourceManager.registerPlugIn("noneAnimator", noneAnimator);

// -------------------------------
// CatMullRom winline animator
// -------------------------------
catMullRomAnimator = {};
catMullRomAnimator.linesPerSymbol = 15;

catMullRomAnimator.playAnimation = function (sequence, callback, maxTime) {
  if (typeof catMullRomAnimator.container === "undefined") {
    // Initialise using reels parent container
    catMullRomAnimator.container = slotMachine.reels[0].parent.parent;
    catMullRomAnimator.graphics = resourceManager.createObject(
      "graphics",
      "graphics",
      catMullRomAnimator.container
    );
  }

  var winlineColours = resourceManager.getConfiguration().winlineColours;
  if (
    checkForUndefined(
      winlineColours,
      "Winline colours were not found in config.json",
      true
    )
  ) {
    return;
  }
  catMullRomAnimator.winlineColour = parseInt(
    winlineColours[sequence.data.winningLine],
    16
  );
  catMullRomAnimator.sequence = sequence;
  catMullRomAnimator.maxTime = maxTime;

  // Get current reel positions
  catMullRomAnimator.recalculateSymbolPositions();
  catMullRomAnimator.createLinePositions(sequence.data.positions);

  // Draw winline
  catMullRomAnimator.symbolsInWinline = sequence.data.positions.length;
  //catMullRomAnimator.drawWinline(1);

  if (typeof sequence.sound !== "undefined") {
    soundManager.play(sequence.sound);
  }

  catMullRomAnimator.animationTime = 0;
  catMullRomAnimator.totalAnimationTime =
    200 + 70 * catMullRomAnimator.symbolsInWinline;
  if (checkForDefined(catMullRomAnimator.maxTime)) {
    catMullRomAnimator.totalAnimationTime = Math.min(
      catMullRomAnimator.maxTime,
      catMullRomAnimator.totalAnimationTime
    );
  }
  catMullRomAnimator.symbolAnimationTime =
    catMullRomAnimator.totalAnimationTime / 3;

  catMullRomAnimator.callback = callback;
  Reflex.addToUpdate(catMullRomAnimator.update);
};

catMullRomAnimator.skipAnimation = function () {
  catMullRomAnimator.animationTime = catMullRomAnimator.totalAnimationTime;
};

catMullRomAnimator.createLinePositions = function (winlinePositions) {
  // This function creates a list of positions that CatMullRom uses for this winline only
  // It's a reference into the positions array created in recalculateSymbolPositions()
  catMullRomAnimator.linePositions = [];
  catMullRomAnimator.linePositions.push(
    catMullRomAnimator.symbolPositions[winlinePositions[0].reel][
      winlinePositions[0].row
    ]
  );
  for (var i = 0; i < winlinePositions.length; i++) {
    catMullRomAnimator.linePositions.push(
      catMullRomAnimator.symbolPositions[winlinePositions[i].reel + 1][
        winlinePositions[i].row
      ]
    );
  }
  catMullRomAnimator.linePositions.push(
    catMullRomAnimator.symbolPositions[winlinePositions[i - 1].reel + 2][
      winlinePositions[i - 1].row
    ]
  );
};

catMullRomAnimator.recalculateSymbolPositions = function () {
  // This function recalculates screen positions for every single symbol, plus virtual symbols to the left and right for CatMullRom to use
  var positions;
  var slotMachine = catMullRomAnimator.sequence.slotMachine;
  catMullRomAnimator.symbolPositions = [];

  // Create "pre" reel
  positions = [];
  for (var j = 0; j < slotMachine.reels[0].configParams.appertureHeight; j++) {
    var pos = catMullRomAnimator.getPosition(0, j);
    pos.x -= slotMachine.reels[0].symbolWidth;
    positions.push(pos);
  }
  catMullRomAnimator.symbolPositions.push(positions);

  for (var i = 0; i < slotMachine.reels.length; i++) {
    positions = [];

    for (
      var j = 0;
      j < slotMachine.reels[i].configParams.appertureHeight;
      j++
    ) {
      positions.push(catMullRomAnimator.getPosition(i, j));
    }

    catMullRomAnimator.symbolPositions.push(positions);
  }

  // Create "post" reel
  positions = [];
  var lastReelIndex = slotMachine.reels.length - 1;
  for (
    var j = 0;
    j < slotMachine.reels[lastReelIndex].configParams.appertureHeight;
    j++
  ) {
    var pos = catMullRomAnimator.getPosition(lastReelIndex, j);
    pos.x += slotMachine.reels[lastReelIndex].symbolWidth;
    positions.push(pos);
  }
  catMullRomAnimator.symbolPositions.push(positions);
};

catMullRomAnimator.getPosition = function (reel, row) {
  var offsetY = reelManager.reels[reel].configParams.appertureSpacing;
  var reelPosX =
    reelManager.reels[reel].Props[layoutController.getCurrentLayout()].position
      .x +
    reelManager.reels[reel].symbolWidth / 2;
  var reelPosY =
    reelManager.reels[reel].Props[layoutController.getCurrentLayout()].position
      .y +
    offsetY / 2;

  return { x: reelPosX, y: reelPosY + offsetY * row };
};

catMullRomAnimator.update = function (delta) {
  catMullRomAnimator.animationTime += delta;

  if (
    catMullRomAnimator.animationTime > catMullRomAnimator.totalAnimationTime
  ) {
    catMullRomAnimator.graphics.clear();
    Reflex.removeFromUpdate(catMullRomAnimator.update);
    catMullRomAnimator.callback();
  } else {
    if (
      catMullRomAnimator.animationTime < catMullRomAnimator.symbolAnimationTime
    ) {
      catMullRomAnimator.drawWinline(
        catMullRomAnimator.animationTime /
          catMullRomAnimator.symbolAnimationTime
      );
    } else {
      catMullRomAnimator.drawWinline(1);
    }
  }
};

catMullRomAnimator.onGameConfigEvent = function (gameConfigTask) {
  if (gameConfigTask.data.slotConfig === undefined) return;

  var winlines = gameConfigTask.data.slotConfig.paylines;
  catMullRomAnimator.winlinesLUT = [];
  for (var i = 0; i < winlines.length; i++) {
    catMullRomAnimator.winlinesLUT.push([]);
    catMullRomAnimator.winlinesLUT[i].push({ x: 0, y: winlines[i].spots[0] });
    for (var j = 0; j < winlines[i].spots.length; j++) {
      catMullRomAnimator.winlinesLUT[i].push({
        x: j + 1,
        y: winlines[i].spots[j],
      });
    }
    catMullRomAnimator.winlinesLUT[i].push({
      x: j + 1,
      y: winlines[i].spots[j - 1],
    });
  }
};

catMullRomAnimator.drawPartialWinline = function (segment, progress) {
  for (var j = 0; j < catMullRomAnimator.linesPerSymbol; j++) {
    if (progress > j / catMullRomAnimator.linesPerSymbol) {
      var from = InterpolationHelper.CatmullRom(
        catMullRomAnimator.linePositions[segment],
        catMullRomAnimator.linePositions[segment + 1],
        catMullRomAnimator.linePositions[segment + 2],
        catMullRomAnimator.linePositions[segment + 3],
        j / catMullRomAnimator.linesPerSymbol
      );

      var to = InterpolationHelper.CatmullRom(
        catMullRomAnimator.linePositions[segment],
        catMullRomAnimator.linePositions[segment + 1],
        catMullRomAnimator.linePositions[segment + 2],
        catMullRomAnimator.linePositions[segment + 3],
        j / catMullRomAnimator.linesPerSymbol +
          1 / catMullRomAnimator.linesPerSymbol
      );

      catMullRomAnimator.graphics.moveTo(from.x, from.y);
      catMullRomAnimator.graphics.lineTo(to.x, to.y);
    }
  }
};

catMullRomAnimator.drawWinline = function (progress) {
  catMullRomAnimator.graphics.clear();

  var totalSymbols = (catMullRomAnimator.symbolsInWinline - 1) * progress;
  var fullSymbols = Math.floor(totalSymbols);
  catMullRomAnimator.graphics.lineStyle(6, catMullRomAnimator.winlineColour, 1);

  for (var i = 0; i < fullSymbols; i++) {
    catMullRomAnimator.drawPartialWinline(i, 1);
  }

  catMullRomAnimator.drawPartialWinline(i, totalSymbols - fullSymbols);
};

catMullRomAnimator.onLayoutComplete = function () {
  messageBus.subscribe(
    "spinner:GameConfigEvent",
    catMullRomAnimator.onGameConfigEvent
  );
};

//resourceManager.registerPlugIn("catMullRomAnimator", catMullRomAnimator);
//Reflex.registerEventHandler("ready", catMullRomAnimator.onLayoutComplete);

// -------------------------------
// Highlight box animator
// -------------------------------

highlightBoxAnimator = {};

highlightBoxAnimator.playAnimation = function (sequence, callback, maxTime) {
  highlightBoxAnimator.completeCallback = callback;
  highlightBoxAnimator.sequence = sequence;
  highlightBoxAnimator.maxTime = maxTime;

  if (checkForUndefined(highlightBoxAnimator.maxTime)) {
    highlightBoxAnimator.maxTime = 999999999;
  }

  if (
    checkForUndefined(
      sequence.sound,
      "No sounds was defined for sequence",
      true
    )
  )
    return;
  highlightBoxAnimator.soundFinished = false;
  soundManager.play(sequence.sound, highlightBoxAnimator.onSoundFinished);

  for (
    var i = 0;
    i < highlightBoxAnimator.sequence.data.positions.length;
    i++
  ) {
    var reel = highlightBoxAnimator.sequence.data.positions[i].reel;
    var row = highlightBoxAnimator.sequence.data.positions[i].row;
    for (
      var j = 0;
      j < reelManager.reels[reel].linkedReelBoxStrips.length;
      j++
    ) {
      var reelBoxStrip = resourceManager.get(
        reelManager.reels[reel].linkedReelBoxStrips[j].name
      );
      reelBoxStrip.showBox(
        row,
        sequence.data.winningLine - 1,
        i == 0 ? gdk.formatCurrency(sequence.data.winAmount) : undefined
      );
    }
  }

  highlightBoxAnimator.timePlayed = 0;
  Reflex.addToUpdate(highlightBoxAnimator.update);
};

highlightBoxAnimator.onSoundFinished = function () {
  highlightBoxAnimator.soundFinished = true;
};

highlightBoxAnimator.skipAnimation = function () {
  soundManager.stop(highlightBoxAnimator.sequence.sound);
  highlightBoxAnimator.animationComplete();
};

highlightBoxAnimator.animationComplete = function () {
  for (
    var i = 0;
    i < highlightBoxAnimator.sequence.data.positions.length;
    i++
  ) {
    var reel = highlightBoxAnimator.sequence.data.positions[i].reel;
    var row = highlightBoxAnimator.sequence.data.positions[i].row;
    for (
      var j = 0;
      j < reelManager.reels[reel].linkedReelBoxStrips.length;
      j++
    ) {
      var reelBoxStrip = resourceManager.get(
        reelManager.reels[reel].linkedReelBoxStrips[j].name
      );
      reelBoxStrip.hideAllBoxes();
    }
  }

  Reflex.removeFromUpdate(highlightBoxAnimator.update);
  highlightBoxAnimator.completeCallback();
};

highlightBoxAnimator.update = function (delta) {
  highlightBoxAnimator.timePlayed += delta;
  if (
    highlightBoxAnimator.soundFinished ||
    highlightBoxAnimator.timePlayed >= highlightBoxAnimator.maxTime
  ) {
    if (!highlightBoxAnimator.soundFinished) {
      // We hit max time, so stop sound
      soundManager.stop(highlightBoxAnimator.sequence.sound);
    }

    highlightBoxAnimator.animationComplete();
  }
};

resourceManager.registerPlugIn("highlightBoxAnimator", highlightBoxAnimator);
